import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesService } from '../../services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

  currentLang: string;

  constructor(private translate: TranslateService, private languagesService: LanguagesService) { 
    languagesService.getLanguage().subscribe(lang => this.currentLang = lang);
    this.translate.use(this.currentLang);
  }
}
